import styled from 'styled-components';

import Flex from '/imports/core/ui/atoms/Flex';

const TextWrapper = styled(Flex)`
  gap: 16px;
`;

export default TextWrapper;
